export const navigations = [
  { name: 'Scheduled Jobs', path: '/jobs', icon: 'alarm', auth: ['global', 'job_write'] },
  { name: 'Users', path: '/users', icon: 'groups', auth: ['global', 'user_write'] },
  { name: 'Credentials', path: '/credentials', icon: 'lock', auth: ['global', 'credential_write'] },
  { name: 'Billing Portal', path: 'account/billing-portal', icon: 'receipt', auth: ['global'], type: 'apiUrl' },
  { name: 'API Keys', path: '/api-keys', icon: 'key', auth: ['global'] },
  { name: 'Documentation', path: 'https://www.cloudyscheduler.com/', icon: 'launch', type: 'extLink' }
];
